module.exports = __webpack_public_path__ + "img/violet_018.bb05ca43.png";